import { render, staticRenderFns } from "./testTag.vue?vue&type=template&id=79cc4a93&scoped=true&"
import script from "./testTag.vue?vue&type=script&lang=js&"
export * from "./testTag.vue?vue&type=script&lang=js&"
import style0 from "./testTag.vue?vue&type=style&index=0&id=79cc4a93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cc4a93",
  null
  
)

component.options.__file = "testTag.vue"
export default component.exports